
<template>
	<el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
		unique-opened class="el-menu-vertical-demo" background-color="#fff" text-color="#000"
		active-text-color="#1890FF">
		<div class="logobox">
			<img class="logoimg" src="../../static/11.jpg" alt="" />
			<h1 v-if="ifImg" class="logotext custom-font" style="color: #126989" @click="goHomepage">
				简牍科技
			</h1>
		</div>
		<el-menu-item v-for="(arrmenu, index) in allmenu" v-if="arrmenu.menus == null" :key="arrmenu.menuid"
			:index="'/' + arrmenu.url" v-show="arrmenu.is_display != 0" class="el-menu-text">
			<i class="iconfont" :class="arrmenu.icon"></i>
			<span slot="title">{{ arrmenu.menuname }}</span>
		</el-menu-item>

		<el-submenu v-for="(menu, menuIndex) in allmenu" :key="menu.menuid" :index="'/' + menu.url"
			v-if="menu.menus !== null" v-show="menu.is_display != 0" class="el-menu-text">
			<template slot="title">
				<i class="iconfont" :class="menu.icon"></i>
				<span>{{ menu.menuname }}</span>
			</template>
			<el-menu-item-group>
				<el-menu-item v-for="chmenu in menu.menus" :index="'/' + chmenu.url" v-show="chmenu.is_display != 0"
					:key="chmenu.menuid">
					<i class="iconfont" :class="chmenu.icon"></i>
					<span>{{ chmenu.menuname }}</span>
				</el-menu-item>
			</el-menu-item-group>
		</el-submenu>
		<!-- <el-menu-item index="4">
      <i class="el-icon-setting"></i>
      <span slot="title">导航四</span>
    </el-menu-item> -->
	</el-menu>
</template>
<script>
	import {
		mapState
	} from "vuex";
	import {
		menu
	} from "../api/userMG";
	import {
		getPermissionList
	} from "../api/permission";
	import {
		getUserInfo
	} from "../api/userMG";
	export default {
		name: "leftnav",
		data() {
			return {
				collapsed: false,
				allmenu: [],
				ifImg: true,
			};
		},
		computed: {
			...mapState(["routerData"]),
		},
		methods: {
			goHomepage() {
				window.open("https://www.tfw2020.com/", "_blank");
			},
			// //对比数组
			updateIcon(list, result) {
				return list.map((item) => {
					if (item.url) {
						const match = result.find((r) => Number(r.url) == item.menuid);
						item.is_display = match ? 1 : 0;
					}
					if (item.menus && item.menus.length > 0) {
						item.menus = this.updateIcon(item.menus, result);
					}
					return item;
				});
			},
			getPermissionLists(callback) {
				getUserInfo().then((res) => {
					console.log(res)
					localStorage.setItem('userId', res.data.user.id);
					let rdata = this.routerData;
					if (res.data.user.id == "1") {
						rdata.forEach((item) => {
							item.is_display = 1;
							if (item.menus) {
								item.menus.forEach(sitem => {
									sitem.is_display = 1;
								})
							}
						});
					} else {
						const arrs = res.data.user.permissions;
						this.updateIcon(rdata, arrs);
					}
					if (callback) {
						callback(rdata);
					}
				});
			},
		},
		// 创建完毕状态(里面是操作)
		mounted() {
			// 获取图形验证码
			this.getPermissionLists((res) => {
				this.allmenu = res;
				console.log('导航栏状态：', res);
			});

			this.$root.Bus.$on("toggle", (value) => {
				this.collapsed = !value;
				this.ifImg = value;
			});
		},
	};
</script>
<style>
	.el-menu-text {
		width: 28vh;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		min-height: 400px;
		width: 220px;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		border: none;
		text-align: left;
	}

	.el-menu-item-group__title {
		padding: 0px;
	}

	.el-menu-bg {
		background-color: #1f2d3d !important;
	}

	.el-menu {
		border: none;
	}

	.logobox {
		padding: 25px;
		/* height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px; */
	}

	.logoimg {
		width: 40px;
		height: 40px;
		vertical-align: middle;
		margin-right: 12px;
	}

	.logotext {
		cursor: pointer;
		display: inline-block;
		margin: 0;
		color: #fff;
		font-weight: 600;
		line-height: 50px;
		font-size: 14px;
		font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
		vertical-align: middle;
	}

	.custom-font {
		font-family: Arial, sans-serif;
		font-size: 28px;
		font-weight: bold;
		font-style: italic;
		text-align: center;
		text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
		animation: glow 1s ease-in-out infinite;
	}

	@keyframes glow {
		0% {
			text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
		}

		50% {
			text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
		}

		100% {
			text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue